export interface GeoSite {
    _id: string,
    siteName: string,
    city: string,
    country: string,
    categoryid: string,
    categoryName: string,
    subcategoryid: string,
    subCategoryName: string,
    location: any,
    poly: any,
    geoJson: string
}

export interface GeoFilter {
    locationType: any,
    visitOperator: any,
    visit: any,
    visitRange: any,
    age: any,
    ageOperator: any,
    ageRange: any,
    filterFromDate: any,
    filterToDate: any,
    radius: any,
    segOpt: any,
    geoSite: any,
    segId: string,
    drawMapType: any,
    ageType: any,
    segmentType: any,
    visitType: any,
    saveType: any,
    questionName: any,
    savedQuestionType: any,
    savedQuestion: any
}

export enum GeoFilterNext {
    locationType = "locationType",
    locationTypeTitle = "Select a Geo-site Type",
    geoSite = "site",
    geoSiteTitle = "List of Existing Geo-sites",
    drawMap = "drawMap",
    drawMapTitle = "Draw a Geo site",
    drawMapType = "drawMapType",
    drawMapTypeTitle = "Custom Geo-site Type",
    drawSite = "drawSite",
    customlocation = "customlocation",
    geoRadius = "geoRadius",
    geoRadiusTitle = "Select a point with Geo-radius",
    ageType = "ageType",
    ageTypeTitle = "Age Selection",
    segmentType = "segmentType",
    segmentTitle = "Segment Selection",
    visitType = "visitType",
    visitTitle = "Visit Frequency",
    dateType = "dateType",
    dateTitle = "Date Selection",
    saveType = "saveType",
    saveTitle = " Save the Question",
    showAns = "showAns",
    showAnsTitle = "Summary of Question",
}


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/interface/geosite.ts